import { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { Box, CircularProgress, Avatar, Container, Grid, IconButton, Typography, Modal, Button, InputLabel, TextField, FormControlLabel, Radio } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Swal from 'sweetalert2';
import Select from "react-select";
import moment from 'moment';
import GroupIcon from '@mui/icons-material/Group';

const TherapistRequest = () => {
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const token = localStorage.getItem('Token')
    const auth = `Bearer ${token}`
    const headers = {
        Authorization: auth
    }
    const statusOptions = [
        { value: "all", label: "All" },
        { value: "approved", label: "Approved" },
        { value: "rejected", label: "Rejected" }
    ];
    const [selectedStatus, setSelectedStatus] = useState(statusOptions[0]);
    const fetchRequests = async (status) => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/TherapistRequest/GetAllRequests?requestString=${status.value}`,
                // {},  
                { headers }
            );

            setRows(response);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchRequests(selectedStatus);
    }, [selectedStatus]);

    const [selectedTherapistId, setSelectedTherapistId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [ActionRowid, setActionRowid] = useState(null);
    const [UserData, setUserData] = useState(null);

    const handleOpenModal = (therapistId) => {
        setSelectedTherapistId(therapistId);
        setModalOpen(true);
    };


    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedTherapistId(null);
        setActionRowid(null)
        setUserData(null)

    };
    const columns = [
        {
            field: 'therapistName',
            headerClassName: 'super-app-theme--header',
            headerName: 'User Name',
            cellClassName: 'gridCell',
            flex: 0.4,
            renderCell: (cell) => (
                <Button
                    style={{
                        justifyContent: 'flex-start',
                        textTransform: 'none',
                        width: '100%', // Ensures the button takes full width
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                    size='small'
                    variant='text'
                    color='info'
                    onClick={() => {
                        setActionRowid(cell.row.id);
                        handleOpenModal(cell.row.id);
                    }}
                >
                    {`${cell.row.therapistName}`}</Button>
            ),
        },
        {
            field: 'licenseNumber',
            headerClassName: 'super-app-theme--header',
            headerName: 'License #',
            cellClassName: 'gridCell',
            flex: 0.2
        },
        {
            field: 'licenseState',
            headerClassName: 'super-app-theme--header',
            headerName: 'State',
            cellClassName: 'gridCell',
            flex: 0.2
        },
        {
            field: 'licenseType',
            headerClassName: 'super-app-theme--header',
            headerName: 'License Type',
            cellClassName: 'gridCell',
            flex: 0.35
        },
        {
            field: "approve",
            headerClassName: "super-app-theme--header",
            headerName: "Approved",
            cellClassName: "gridCell",
            flex: 0.2,
            renderCell: (params) => (
                params.value ? (
                    <CheckCircleIcon sx={{ color: '#22d155' }} />
                ) : (
                    <CancelOutlinedIcon sx={{ color: 'red' }} />
                )
            ),
        }

    ];

    const gridRowStyle = {
        boxShadow: 2,
        border: 2,
        borderRadius: 2,
        background: 'drak',
        height: '300px',
        fontSize: '13.4px !important',
        color: 'drak !important',
        borderColor: '#C2A27C',
        '& .MuiDataGrid-cell:hover': {
            color: 'rgba(5, 152, 236, 0.637) !important',
            fontSize: '14.6px !important',
        },
        '& .super-app-theme--header': {
            background: '#C2A27C',
            borderRadius: 0.1,
            color: 'white',
            fontSize: '16px !important',

        },

    }
    const gridClasses = {
        columnHeader: 'MuiDataGrid-columnHeaders',
    };
    const modalStyleLink = {
        position: "absolute",
        top: "50%",
        left: "58%",
        transform: "translate(-50%, -50%)",
        width: 1000,
        height: 700, // Set fixed height
        maxHeight: "90vh", // Ensures it doesn’t go beyond viewport height
        bgcolor: "white",
        borderRadius: "10px",
        boxShadow: 24,
        p: 3,
        border: "2px solid #C2A27C",
        overflowY: "auto", // Enables vertical scroll if content overflows
        "&::-webkit-scrollbar": {
            width: "12px", // Thickness of the scrollbar
        },
        "&::-webkit-scrollbar-track": {
            background: "#f1f1f1", // Track color
            borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#C2A27C", // Scrollbar color
            borderRadius: "10px",
            border: "3px solid #f1f1f1", // Adds padding effect
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#A08A67", // Darker shade on hover
        },
    };
    const [ImageOfUser, setImageOfUser] = useState('');

    useEffect(() => {
        if (selectedTherapistId) {
            setIsLoading(true)
            axios
                .get(`${process.env.REACT_APP_API_URL}/TherapistRequest/GetRequestById?requestId=${selectedTherapistId}`, {
                    headers
                })
                .then(response => {
                    setUserData(response)
                    setIsLoading(false)
                    if (response?.therapistProfilePic) {
                        axios.get(`${process.env.REACT_APP_API_URL}/UserDocument/ViewPatientDocument?path=${response.therapistProfilePic}`,{ headers })
                            .then(profileResponse => {
                                setImageOfUser(profileResponse)
                            })
                            .catch(profileError => {
                                console.error("Error fetching profile image:", profileError);
                            });
                    }
                })
                .catch(error => { })
                .finally(() => {
                    setIsLoading(false); // Stop loading after request completes
                });
        }
    }, [modalOpen]);

    const handleApproveRequest = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/TherapistRequest/ApproveRequest?requestId=${ActionRowid}`,
                {},
                { headers }
            );
            handleCloseModal()
            Swal.fire("Success", "Request approved successfully!", "success");
        } catch (error) {
            handleCloseModal()
            Swal.fire("Error", "Something went wrong!", "error");
            console.error("Approval error:", error);
        }
    }

    const handleRejectRequest = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/TherapistRequest/RejectRequest?requestId=${ActionRowid}`,
                {},
                { headers }
            );
            handleCloseModal()
            Swal.fire("Success", "Request Reject successfully!", "success");
        } catch (error) {
            handleCloseModal()
            Swal.fire("Error", "Something went wrong. Please try again!", "error");
            console.error("Reject error:", error);
        }
    };
    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 800,
        height: 500, // Set fixed height
        maxHeight: "90vh", // Ensures it doesn’t go beyond viewport height
        bgcolor: "#3A6A57",
        borderRadius: "10px",
        boxShadow: 24,
        p: 3,
        border: "2px solid #C2A27C",
        zindex: 999,
        overflowY: "auto", // Enables vertical scroll if content overflows
        "&::-webkit-scrollbar": {
            width: "8px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#C2A27C",
            borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#3A6A57",
            borderRadius: "10px",
            border: "2px solid #C2A27C",
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#2E5544",
        },
        scrollbarColor: "#3A6A57 #C2A27C",
        scrollbarWidth: "thin",
    };
    return (
        <div className="page-content">
            <Modal open={modalOpen} onClose={handleCloseModal}>
                {/* <Box sx={modalStyleLink}>
                    <Grid item xs={12}>
                        <Grid container alignItems="center" style={{ background: '#C2A27C', borderRadius: '8px', padding: '10px' }}>
                            <Grid item xs={11}>
                                <Typography variant="h6" style={{ color: '#fff', fontWeight: 'bold' }}>
                                    SUPERVISEE INFO
                                </Typography>
                            </Grid>
                            <Grid item xs={1} style={{ textAlign: 'right' }}>
                                <CancelOutlinedIcon
                                    onClick={handleCloseModal}
                                    style={{ color: 'red', cursor: 'pointer' }}
                                />
                            </Grid>
                        </Grid>
                        {isLoading ? (
                            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            <Grid container spacing={1}>

                                <Grid item xs={6}>
                                    <InputLabel sx={{ fontWeight: 'bold', color: 'gray', mb: 0.5 }}>Supervisee Name</InputLabel>
                                    <Typography variant="body1" sx={{ fontSize: '1rem', color: 'black', fontWeight: '500', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                        {UserData && UserData.therapistName ? UserData.therapistName : 'N/A'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <InputLabel sx={{ fontWeight: 'bold', color: 'gray', mb: 0.5 }}>Email</InputLabel>
                                    <Typography variant="body1" sx={{ fontSize: '1rem', color: 'black', fontWeight: '500', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                        {UserData && UserData.email ? UserData.email : 'N/A'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <InputLabel sx={{ fontWeight: 'bold', color: 'gray', mb: 0.5 }}>License Expiration Date</InputLabel>
                                    <Typography variant="body1" sx={{ fontSize: '1rem', color: 'black', fontWeight: '500', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                        {UserData && UserData.licenseExpirationDate ? moment(UserData.licenseExpirationDate).format('MM-DD-YYYY') : 'N/A'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <InputLabel sx={{ fontWeight: 'bold', color: 'gray', mb: 0.5 }}>License Number</InputLabel>
                                    <Typography variant="body1" sx={{ fontSize: '1rem', color: 'black', fontWeight: '500', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                        {UserData && UserData.licenseNumber ? UserData.licenseNumber : 'N/A'}
                                    </Typography>
                                </Grid>


                                <Grid item xs={6}>
                                    <InputLabel sx={{ fontWeight: 'bold', color: 'gray', mb: 0.5 }}>License State</InputLabel>
                                    <Typography variant="body1" sx={{ fontSize: '1rem', color: 'black', fontWeight: '500', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                        {UserData && UserData.licenseState ? UserData.licenseState : 'N/A'}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <InputLabel sx={{ fontWeight: 'bold', color: 'gray', mb: 0.5 }}>License Type</InputLabel>
                                    <Typography variant="body1" sx={{ fontSize: '1rem', color: 'black', fontWeight: '500', p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                        {UserData && UserData.licenseType ? UserData.licenseType : 'N/A'}
                                    </Typography>
                                </Grid>

                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        sx={{
                                            mt: 2,
                                            py: 1.5,
                                            backgroundColor: "#C2A27C",
                                            fontWeight: "bold",
                                            fontSize: "1rem",
                                            boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.3)",
                                            borderRadius: "8px",
                                            "&:hover": { backgroundColor: "#B2956E" },
                                        }}
                                        onClick={handleApproveRequest}
                                    >
                                        Approve Request
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        sx={{
                                            mt: 2,
                                            py: 1.5,
                                            backgroundColor: "#C2A27C",
                                            fontWeight: "bold",
                                            fontSize: "1rem",
                                            boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.3)",
                                            borderRadius: "8px",
                                            "&:hover": { backgroundColor: "#B2956E" },
                                        }}
                                        onClick={handleRejectRequest}
                                    >
                                        Cancel Request
                                    </Button>
                                </Grid>

                            </Grid>
                        )}
                    </Grid>
                </Box> */}
                <Box sx={modalStyle}>

                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <Grid container alignItems="center" sx={{ background: "#C2A27C", borderRadius: "8px", padding: "10px" }}>
                                <Grid item xs={11}>
                                    <Typography variant="h6" sx={{ color: "#fff", fontWeight: "bold" }}>
                                        <GroupIcon sx={{ fontSize: 35, }} />  Supervisee Request Form
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "right" }}>
                                    <CancelOutlinedIcon onClick={handleCloseModal} sx={{ color: "red", cursor: "pointer" }} />
                                </Grid>
                            </Grid>
                        </Grid>
                        {isLoading ? (
                            <Box display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="50vh"
                            width="100%" >
                                <CircularProgress sx={{ color: "#C2A27C"}} />
                            </Box>
                        ) : (
                            <>
                                <Grid item xs={4}>
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <Avatar
                                            sx={{ width: 130, height: 130, border: "3px solid white" }}
                                            src={`${ImageOfUser}`}
                                            alt="Profile Picture"
                                        />
                                        <Typography variant="body1" sx={{
                                            maxWidth: '90%',
                                            color: "#C2A27C",
                                            marginLeft: '20px',
                                            wordWrap: 'break-word',
                                            whiteSpace: 'pre-wrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: 'block',
                                            textAlign: 'center'
                                        }}>{UserData && UserData.licenseType ? UserData.licenseType : 'N/A'}<strong> | {UserData && UserData.licenseState ? UserData.licenseState : 'N/A'}</strong> </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={8}>
                                    <Grid container spacing={1} >
                                        <Grid item xs={12} >
                                            <Typography variant="body1" sx={{ color: "#fff" }}><strong>First Name:</strong> {UserData && UserData.therapistName ? UserData.therapistName : 'N/A'}</Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Typography variant="body1" sx={{ color: "#fff" }}><strong>Email:</strong>{UserData && UserData.therpistEmail ? UserData.therpistEmail : 'N/A'}</Typography>
                                        </Grid>
                                        <Grid item xs={6} >
                                            <Typography variant="body1" sx={{ color: "#fff" }}><strong>Phone:</strong>{UserData && UserData.therpistPhone ? UserData.therpistPhone : 'N/A'}</Typography>
                                        </Grid>
                                        <Grid item xs={6} ></Grid>
                                        <Grid item xs={6} >
                                            <Typography variant="body1" sx={{ color: "#fff" }}><strong>Currently Under Supervison:</strong> </Typography>
                                        </Grid>
                                        <Grid item xs={6} >
                                            <Box display="flex" alignItems="center">
                                                <FormControlLabel
                                                    control={
                                                        <Radio
                                                            checked={UserData && UserData.underSupervison === true ? true : false}
                                                            // onChange={handleChange}
                                                            value="yes"
                                                        />
                                                    }
                                                    label="YES"
                                                    sx={{ color: '#fff' }}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Radio
                                                            checked={UserData && UserData.underSupervison === false ? true : false}
                                                            // onChange={handleChange}
                                                            value="no"
                                                        />
                                                    }
                                                    label="NO"
                                                    sx={{ color: '#fff' }}
                                                />
                                            </Box>
                                        </Grid>
                                        {/* <Grid item xs={6} >
                                    <Typography variant="body1" sx={{ color: "#fff" }}><strong>Direct Hours Completed:</strong>{UserData && UserData.directhourshave ? UserData.directhourshave : 'N/A'}</Typography>
                                </Grid>
                                <Grid item xs={6} >
                                    <Typography variant="body1" sx={{ color: "#fff" }}><strong>Indirect Hours Completed:</strong>{UserData && UserData.indirecthourshave ? UserData.indirecthourshave : 'N/A'}</Typography>
                                </Grid> */}
                                        <Grid item xs={12}>
                                            <Typography variant="body1" sx={{ color: "#fff" }}><strong>Brief Bio:</strong></Typography>
                                            <TextField fullWidth multiline rows={2} value={UserData && UserData.briefBio ? UserData.briefBio : 'N/A'} placeholder="Please provide a brief bio. 150 word count" variant="outlined" sx={{ backgroundColor: "#fff", borderRadius: "5px" }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body1" sx={{ color: "#fff" }}><strong>Comments:</strong></Typography>
                                    <TextField fullWidth multiline rows={1} value={UserData && UserData.comments ? UserData.comments : 'N/A'} placeholder="Please provide additional comments related to your request. 150 words max." variant="outlined" sx={{ backgroundColor: "#fff", borderRadius: "5px" }} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        // onClick={handleSave}
                                        sx={{
                                            backgroundColor: "#C2A27C",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            boxShadow: "4px 4px 5px rgba(0, 0, 0, 0.3)",
                                            "&:hover": { backgroundColor: "#A9906C" }
                                        }}
                                        onClick={handleApproveRequest}
                                    >
                                        Approve Request
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        // onClick={handleSave}
                                        sx={{
                                            backgroundColor: "#C2A27C",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            boxShadow: "4px 4px 5px rgba(0, 0, 0, 0.3)",
                                            "&:hover": { backgroundColor: "#A9906C" }
                                        }}
                                        onClick={handleRejectRequest}
                                    >
                                        Cancel Request
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </Grid>

                </Box>
            </Modal>
            <Container>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Box mb={2}>
                            <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={setSelectedStatus}
                                isSearchable={false}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box mb={2} style={{ height: 400, width: "100%" }}>
                            {isLoading ? (
                                <div style={{ textAlign: "center", marginTop: "2rem" }}>
                                    <CircularProgress />
                                </div>
                            ) : rows.length === 0 ? (
                                "No Record Found"
                            ) : (
                                <DataGrid
                                    rows={rows}
                                    classes={gridClasses}
                                    rowHeight={20}
                                    columns={columns}
                                    fullWidth
                                    sx={gridRowStyle}
                                    pagination
                                    autoPageSize
                                />
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};

export default TherapistRequest;
